import { Component, computed } from '@angular/core';
import { NetworkConnectionService } from '../../services/network-connection.service';
import { NgIf } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { Subject, takeUntil } from 'rxjs';

@Component({
    imports: [NgIf, TranslateModule],
    selector: 'app-offline',
    templateUrl: './offline.component.html',
    styleUrls: ['./offline.component.css']
})
export class OfflineComponent {
  isOffline = false;
  private destroy$ = new Subject<void>();

  constructor(private network: NetworkConnectionService) {}

  ngOnInit(): void {
    this.network.online$
      .pipe(takeUntil(this.destroy$))
      .subscribe((isOnline: boolean) => {
        this.isOffline = !isOnline;
      });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
